import { HttpClient } from '@angular/common/http';
import { DestroyRef, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CatalogueProductsResponse } from '@banyan/commons/models/catalog-product-response.model';
import { CatalogProduct } from '@banyan/commons/models/fragrance-catalog/catalog-product.model';
import { ProgressSpinnerService } from '@banyan/modules/shared/services/progress-spinner/progress-spinner.service';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class FragranceCatalogService {
  private readonly PATH: string = '/catalog/products';
  httpClient = inject(HttpClient);
  destroyRef = inject(DestroyRef);
  progressSpinnerService = inject(ProgressSpinnerService);
  catalog = signal<CatalogueProductsResponse | null>(null);
  products = signal<CatalogProduct[]>([]);
  product = signal<CatalogProduct | null>(null);

  getCatalog(limit: number, page: number): void {
    this.progressSpinnerService.show();
    this.httpClient.get<CatalogueProductsResponse>(`${environment.middlewareUrl}${this.PATH}?limit=${limit}&page=${page}`)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (data) => {
          this.catalog.set(data);
          this.progressSpinnerService.hide();
        },
        error: () => {
          this.progressSpinnerService.hide();
        },
      });
  }

  getProduct(id: number) {
    this.progressSpinnerService.show();
    this.httpClient.get<CatalogProduct>(
      `${environment.middlewareUrl}${this.PATH}/${id}`,
    ).pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        {
          next: (data) => {
            if (data) {
              this.product.set(data);
              this.progressSpinnerService.hide();
            }
          },
          error: () => {
            this.progressSpinnerService.hide();
          },
        });
  }
}